import type { ListedOffer } from "@/lib/offersApi";
import {
  fetchActiveAndExpiredOffers,
  mergeActiveAndExpiredToListed,
} from "@/lib/offersApi";

export async function loadOffersListClient(
  langCode: "en" | "ar",
  dealOnly?: boolean
): Promise<{ offers: ListedOffer[] }> {
  const data = await fetchActiveAndExpiredOffers(langCode, dealOnly);
  if (!data) throw new Error("offers fetch failed");
  const offers = mergeActiveAndExpiredToListed(data.result);
  return { offers };
}
